import { Button } from './Button/Button';

export type ButtonConfig = {
  label: string;
  cyTag: string;
  disabled?: boolean;
  onClick?: () => void;
  isSubmit?: boolean;
};

export type FooterConfig = {
  primaryButton: ButtonConfig;
  secondaryButton?: ButtonConfig;
  backButton?: ButtonConfig;
};

export const ButtonFooter = (props: FooterConfig) => {
  const { primaryButton, secondaryButton, backButton } = props;
  return (
    <div className="sticky bottom-0 z-0 flex flex-col gap-4 border-t border-grey-800 bg-white pt-4 pb-2 sm:flex-row">
      {backButton && (
        <Button
          className="w-full sm:w-auto"
          colorVariant="tertiary"
          type={backButton.isSubmit ? 'submit' : 'button'}
          cyTag={backButton.cyTag}
          disabled={backButton.disabled}
          label={backButton.label}
          onClick={backButton.onClick}
        />
      )}
      <div className="flex w-full flex-col gap-4 sm:ml-auto sm:w-auto sm:flex-row">
        {secondaryButton && (
          <Button
            className="w-full sm:w-auto"
            colorVariant="secondary"
            type={secondaryButton.isSubmit ? 'submit' : 'button'}
            cyTag={secondaryButton.cyTag}
            disabled={secondaryButton.disabled}
            label={secondaryButton.label}
            onClick={secondaryButton.onClick}
          />
        )}
        <Button
          className="w-full sm:w-auto"
          type={primaryButton.isSubmit ? 'submit' : 'button'}
          cyTag={primaryButton.cyTag}
          disabled={primaryButton.disabled}
          label={primaryButton.label}
          onClick={primaryButton.onClick}
        />
      </div>
    </div>
  );
};
